var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('h2',{staticClass:"chart__title"},[_vm._t("title"),_c('VTooltip',{scopedSlots:_vm._u([{key:"popper",fn:function(){return [_vm._t("tooltip")]},proxy:true}],null,true)},[(_vm.infoRef)?_c('span',{staticClass:"icon-info"}):_vm._e()])],2),(_vm.showEmptyChart)?_c('EmptyChart'):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }